import React from "react";
import PhoneInput, { parsePhoneNumber, isValidPhoneNumber as isValidNumber } from "react-phone-number-input";
import { useField } from "formik";
import { at } from "lodash";
import { Box, FormHelperText, Typography } from "@mui/material";
import CustomPhoneInput from "./CustomPhoneInput";
import * as Yup from 'yup';

const isValidPhoneNumber = (value) => {
  if (!value){return true;}  
  const phoneNumber = parsePhoneNumber(value);
  return phoneNumber && isValidNumber(value);
};

export const phoneValidationSchema = Yup.string()
  .test('isValidPhoneNumber', 'Please enter valid number', value => isValidPhoneNumber(value));

const PhoneInputField = ({ setFieldValue, required, ...props }) => {
  const [field, meta, helpers] = useField(props.name);
  const [touched, error] = at(meta, "touched", "error");
  const isError = touched && error && true;

  const handleChange = (newValue) => {
    setFieldValue(props.name, newValue || '');
  };

  const handleKeyPress = (event) => {
    // Prevent space from being entered
    if (event.charCode === 32) {
      event.preventDefault();
    }
  };

  return (
    <>
      <Box
        sx={{
          height: props.justifycontent ? "auto" : "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: props.justifycontent ? "start" : "space-between",
        }}
      >
        <Typography
          sx={{ color: "#5b5b5b", fontWeight: "medium" }}
          variant="subtitle1"
          gutterBottom
        >
          {props.label}
          {props.label && required && (
            <span style={{ color: "red", fontSize: 18 }}>*</span>
          )}
        </Typography>
        <PhoneInput
          {...props}
          {...field}
          placeholder={props.placeholder}
          value={field.value}
          // defaultCountry=""
          onKeyPress={handleKeyPress}
          onChange={(value) => {
            handleChange(value);
          }}
          inputComponent={CustomPhoneInput}
        />
        {!isError&& <FormHelperText> </FormHelperText>}
      </Box>
    </>
  );
};

export default React.memo(PhoneInputField);
